export const COLORS = [
    '#4285F4', '#EA4335', '#FBBC05', '#34A853', // Google colors
    '#8E44AD', '#16A085', '#D35400', '#2C3E50', // Rich colors
    '#1ABC9C', '#F39C12', '#E74C3C', '#3498DB', // Bright colors
    '#9B59B6', '#2ECC71', '#E67E22', '#7F8C8D'  // Additional colors
];